<template>
  <div class="sp-index-filters-date-range">
    <h3 v-if="!hasTypes">{{ filter.label }}</h3>
    <sp-select
      v-if="hasTypes"
      v-preserve-properties:items="types"
      :label="filter.label"
      :value.prop="type"
      :data-testid="TestId.admin.indexFilterDateType"
      @change="handleType"
    ></sp-select>
    <sp-date-field
      v-preserve-properties:max-date="maxDate"
      range
      show-months="2"
      shortcuts
      actions
      no-icon
      nav-text
      short-weekdays
      no-today-mark
      location="bottom-right"
      :open="pickerOpen"
      :label="rangeLabel"
      :placeholder="placeholder"
      display-format="M j, Y"
      :value.prop="range"
      :data-testid="TestId.admin.indexFilterDateRange"
      @change="handleRange"
      @update-open="handleOpen"
    ></sp-date-field>
  </div>
</template>

<script setup>
import { vPreserveProperties } from "#ce/utils/property-bindings";
import flatpickr from "flatpickr";
import { TestId } from "#/test-ids";
import { computed, ref, watch } from "vue";
import { useIndexFiltersStore } from "#ce/apps/SpAdmin/SpIndexFilters/store/index-filters";
import { t } from "#ce/apps/SpAdmin/SpIndexFilters/i18n";

const RANGE_SEPARATOR = flatpickr.l10ns.default.rangeSeparator;

const props = defineProps({ filter: { type: Object, required: true } });
const emit = defineEmits(["change"]);
const store = useIndexFiltersStore();
const hasTypes = computed(() => Boolean(props.filter.type_param));
const types = computed(() => props.filter.types.map((item) => ({ title: item.label, value: item.value })));
const type = computed(() => store.values[props.filter.type_param] ?? props.filter.value.type);
const range = computed(() => {
  const start = store.values[props.filter.start_param];
  const end = store.values[props.filter.end_param];

  return start && end ? `${start}${RANGE_SEPARATOR}${end}` : "";
});
const rangeLabel = computed(() => t("date_range"));
const placeholder = computed(() => t("select_date_range"));
const maxDate = computed(() => store.dateBounds(props.filter).maxDate);
const pickerOpen = ref(false);

// The calendar floats above the page, so it closes with the tab and the panel it belongs to.
function closePicker() {
  pickerOpen.value = false;
}

watch(() => [store.activeTab, store.panelOpen], closePicker);

function handleOpen({ detail }) {
  pickerOpen.value = Boolean(detail[0]);
}

function handleType(event) {
  if (store.setDateType(props.filter, event.target.value)) {
    emit("change");
  }
}

function handleRange(event) {
  const [start = null, end = null] = event.target.value ? event.target.value.split(RANGE_SEPARATOR) : [];

  if (store.setDateRange(props.filter, start, end ?? start)) {
    emit("change");
  }
}
</script>
